export function handleIamRedirect(): void {
  const hash = window.location.hash
  if (hash) {
    const hashParams = new URLSearchParams(hash.split('?')[1] || '')
    if (hashParams.has('iamRedirect')) {
      // Add a flag to sessionStorage to indicate that the user should be redirected to IAM for authentication (if needed).
      sessionStorage.setItem('iamRedirect', 'true')

      // Rebuild the URL without the iamRedirect parameter as it is no longer needed and can cause issues depending on how location and
      // history are handled in the application.
      hashParams.delete('iamRedirect')
      const newHash = hash.split('?')[0] + (hashParams.size > 0 ? '?' + hashParams.toString() : '')
      const newUrl = window.location.href.split('#')[0] + newHash
      window.history.replaceState({}, '', newUrl)
    }
  }
}
